// ---------------------------------------------------------------------------
// Digital Notice Board — ElementLibrary (left palette)
// ---------------------------------------------------------------------------
// The "add stuff" panel. Each tile can be dragged onto the canvas (studio-style)
// OR clicked to drop the element at the slide centre — whichever a school user
// finds easier. Dragging carries the element type via the dataTransfer payload
// that DesignCanvas reads on drop.
// ---------------------------------------------------------------------------
import React from "react";
import {Box, SimpleGrid, Text, useColorModeValue, VStack} from "@chakra-ui/react";
import {
    FaClock,
    FaCalendarDay,
    FaFont,
    FaHeading,
    FaImage,
    FaRegSquare,
    FaRegStickyNote,
    FaShapes,
    FaStream,
} from "react-icons/fa";
import {ELEMENT_TYPES} from "../constants/NoticeBoardConstants";

const TILES = [
    {type: ELEMENT_TYPES.HEADING, label: "Heading", Icon: FaHeading},
    {type: ELEMENT_TYPES.TEXT, label: "Text", Icon: FaFont},
    {type: ELEMENT_TYPES.NOTICE, label: "Notice", Icon: FaRegStickyNote},
    {type: ELEMENT_TYPES.IMAGE, label: "Image", Icon: FaImage},
    {type: ELEMENT_TYPES.ICON, label: "Icon", Icon: FaShapes},
    {type: ELEMENT_TYPES.SHAPE, label: "Shape", Icon: FaRegSquare},
    {type: ELEMENT_TYPES.MARQUEE, label: "Scroller", Icon: FaStream},
    {type: ELEMENT_TYPES.CLOCK, label: "Clock", Icon: FaClock},
    {type: ELEMENT_TYPES.DATE, label: "Date", Icon: FaCalendarDay},
];

export default function ElementLibrary({onAdd}) {
    const tileBg = useColorModeValue("gray.50", "gray.700");
    const tileHover = useColorModeValue("blue.50", "gray.600");
    const border = useColorModeValue("gray.200", "gray.600");
    const textColor = useColorModeValue("gray.600", "gray.200");

    return (
        <VStack align="stretch" spacing="12px">
            <Text fontSize="xs" fontWeight="bold" color="gray.400" letterSpacing="0.5px">
                ELEMENTS
            </Text>
            <SimpleGrid columns={2} spacing="10px">
                {TILES.map(({type, label, Icon}) => (
                    <Box
                        key={type}
                        role="button"
                        draggable
                        onDragStart={(e) => e.dataTransfer.setData("application/nb-type", type)}
                        onClick={() => onAdd(type)}
                        bg={tileBg}
                        border="1px solid"
                        borderColor={border}
                        borderRadius="12px"
                        p="12px 8px"
                        textAlign="center"
                        cursor="grab"
                        transition="all 0.15s"
                        _hover={{bg: tileHover, borderColor: "blue.300", transform: "translateY(-2px)"}}
                        _active={{cursor: "grabbing"}}
                    >
                        <Box display="flex" justifyContent="center" mb="6px" color="blue.400">
                            <Icon size={22} />
                        </Box>
                        <Text fontSize="xs" fontWeight="600" color={textColor}>
                            {label}
                        </Text>
                    </Box>
                ))}
            </SimpleGrid>
            <Text fontSize="10px" color="gray.400" lineHeight="1.4">
                Drag a tile onto the screen, or click to drop it in the middle.
            </Text>
        </VStack>
    );
}
